import { ErrorContentComponent } from '../error-content/error-content.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule, ErrorContentComponent],
  selector: 'error-page503',
  templateUrl: './error-503.component.html',
  styles: []
})
export class Error503Component {

}
